import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Landing from "../pages/landing/page";
import Login from "../pages/login/page";
import Dashboard from "../pages/dashboard/page";
import GerarApostas from "../pages/gerar-apostas/page";
import Checkout from "../pages/checkout/page";
import PaymentSuccess from "../pages/payment/success/page";
import PaymentFail from "../pages/payment/fail/page";
import PaymentPending from "../pages/payment/pending/page";
import SuperSetePage from "../pages/super-sete/page";
import SuperSeteResumo from "../pages/super-sete/resumo/page";
import TestLoteriaComponents from "../pages/test-loteria-components/page";
import MeusJogos from "../pages/meus-jogos/page";
import Resultados from "../pages/resultados/page";
import Estatisticas from "../pages/estatisticas/page";
import Notificacoes from "../pages/notificacoes/page";
import { ProtectedRoute } from "../components/ProtectedRoute";
import Express from "../pages/express/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/express",
    element: <Express />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/checkout",
    element: <ProtectedRoute><Checkout /></ProtectedRoute>,
  },
  {
    path: "/payment/success",
    element: <PaymentSuccess />,
  },
  {
    path: "/payment/fail",
    element: <PaymentFail />,
  },
  {
    path: "/payment/pending",
    element: <PaymentPending />,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute><Dashboard /></ProtectedRoute>,
  },
  {
    path: "/gerar-apostas",
    element: <ProtectedRoute requirePro><GerarApostas /></ProtectedRoute>,
  },
  {
    path: "/super-sete",
    element: <ProtectedRoute requirePro><SuperSetePage /></ProtectedRoute>,
  },
  {
    path: "/super-sete/resumo",
    element: <ProtectedRoute requirePro><SuperSeteResumo /></ProtectedRoute>,
  },
  {
    path: "/test-loteria-components",
    element: <ProtectedRoute requirePro><TestLoteriaComponents /></ProtectedRoute>,
  },
  {
    path: "/meus-jogos",
    element: <ProtectedRoute><MeusJogos /></ProtectedRoute>,
  },
  {
    path: "/resultados",
    element: <ProtectedRoute><Resultados /></ProtectedRoute>,
  },
  {
    path: "/estatisticas",
    element: <ProtectedRoute requirePro><Estatisticas /></ProtectedRoute>,
  },
  {
    path: "/notificacoes",
    element: <ProtectedRoute><Notificacoes /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
